// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"04b39d57","488":"fbd48369","977":"bcc537a3"}[chunkId] + ".chunk.js";
};